import { testimonials } from "@/mocks/manga";

const values = [
  { icon: "ri-user-heart-line", title: "以图为引", desc: "用清晰的图谱呈现人物关系，让复杂的角色网络一目了然。" },
  { icon: "ri-quill-pen-line", title: "以文为线", desc: "梳理感情线发展脉络，把CP互动与剧情推进讲明白。" },
  { icon: "ri-heart-add-line", title: "专注人物", desc: "深耕男主女主与全角色的介绍，帮你快速锁定喜欢的配对。" },
];

export default function About() {
  return (
    <section id="about" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <p className="mb-3 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-500">
              <span className="h-px w-8 bg-primary-400" aria-hidden="true"></span>
              关于本站
            </p>
            <h2 className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              做最懂你的 <span className="text-primary-600">漫画角色百科</span>
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-700">
              本站是《恋爱辅助器》爱好者的角色与CP百科站，专注整理
              <strong className="font-semibold text-foreground-900"> 男主女主人物介绍 </strong>
              、角色关系图谱与CP感情线走向。我们坚持把复杂的人物关系梳理成清晰易懂的内容，
              帮助新老读者快速锁定喜欢的角色与配对，让每一段感情线都有迹可循。
            </p>

            <div className="mt-8 grid gap-4 sm:grid-cols-3">
              {values.map((v) => (
                <div key={v.title} className="rounded-2xl border border-background-200/80 bg-background-100 p-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className={v.icon} aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">{v.title}</h3>
                  <p className="mt-1 text-xs leading-6 text-foreground-700">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-xl font-bold text-foreground-950">读者口碑</h3>
            <div className="mt-6 space-y-4">
              {testimonials.map((t) => (
                <figure
                  key={t.name}
                  className="rounded-2xl border-l-4 border-accent-400 bg-background-100 p-5"
                >
                  <div className="flex gap-1 text-accent-500" aria-label="五星好评">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm" aria-hidden="true"></i>
                    ))}
                  </div>
                  <blockquote className="mt-2 text-sm leading-7 text-foreground-800">「{t.text}」</blockquote>
                  <figcaption className="mt-3 flex items-center gap-2 text-xs text-foreground-600">
                    <span className="font-semibold text-foreground-900">{t.name}</span>
                    <span className="h-1 w-1 rounded-full bg-background-300" aria-hidden="true"></span>
                    {t.role}
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}